class BannerCta extends HTMLElement {
  connectedCallback() {
    const urlParams = new URLSearchParams(window.location.search);
    const influencerName = urlParams.get("influencer");

    if (influencerName) {
      const content = this.innerHTML;
      this.innerHTML = content.replace(/\[\[\s*firstName\s*\]\]/g, influencerName);
    } else {
      const content = this.innerHTML;
      this.innerHTML = content.replace(/\[\[\s*firstName\s*\]\]/g, "");
    }
  }
}

customElements.define("banner-cta", BannerCta);
